// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import Vuex from "vuex";
import store from "./store";

import router from "./router";

import "vuetify/dist/vuetify.min.css";
import "font-awesome/css/font-awesome.css";

import vuetify from "./plugins/vuetify";

import "material-design-icons-iconfont/dist/material-design-icons.css";
import "./styles/global.css";

import axios from "axios";
import VueAxios from "vue-axios";

import VueCookie from "vue-cookie";
import VueSweetalert2 from "vue-sweetalert2";

import VueChartkick from "vue-chartkick";
import Chart from "chart.js";
import fullCalendar from "vue-fullcalendar";

import VueTelInputVuetify from "vue-tel-input-vuetify/lib";

import { setupComponents } from "./config/setup-components";

import { setupAndGetI18n } from "./config/setup-i18n";

import underscore from "vue-underscore";

const i18n = setupAndGetI18n(Vue);

import swatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.min.css";
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueChartkick, { adapter: Chart });
Vue.component("full-calendar", fullCalendar);
Vue.component("swatches", swatches);

setupComponents(Vue);
Vue.use(Vuex);
Vue.use(VueCookie);
Vue.use(VueSweetalert2);
Vue.use(VueAxios, axios);
Vue.use(VueTelInputVuetify, {
  vuetify
});

Vue.prototype.$_ = underscore;

Vue.config.productionTip = false;

const axiosConfig = {
  baseURL: process.env.VUE_APP_API_URL + "/" + process.env.VUE_APP_API_VERSION,
  timeout: 60000
};

import api from "./plugins/axios";
Vue.prototype.$axios = api;

// Default vars set up from VueCookie
Vue.prototype.$axios.defaults.headers.common.Authorization = `Bearer ${VueCookie.get(
  "token"
)}`;
Vue.prototype.$axios.defaults.headers.common["Content-Type"] =
  "application/json";

Vue.use(underscore);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  vuetify,
  router,
  i18n,
  store,
  template: "<App/>",
  render: h => h(App),
  data: {
    themeColor: "#23A0A0",
    userEmail: "admin@yopmail.com",
    userPassword: "123456"
  },

  methods: {
    setLanguage(language) {
      const vm = this;

      localStorage.setItem("language", language);

      document.documentElement.lang = language;

      vm.$i18n.locale = language;

      vm.$vuetify.lang.current = language;
    }
  },

  created() {
    const vm = this;
    console.log(this.$vuetify);
    vm.setLanguage("en");
  }
});
